import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('packageVolume', packageVolume);

function packageVolume($filter) {
  return function packageVolumeFilter(packageList, enableUnitDisplay) {

    let totalVolume = 0;
    let hasAnyVolume = false;

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          pkg.items.forEach(item => {
            const volume = item.dimensions?.cube;
            if (volume !== undefined) {
              hasAnyVolume = true;
            }
            totalVolume += volume || 0;
          });
        }
      });
    }

    return hasAnyVolume ? $filter('bringozVolume')(totalVolume, enableUnitDisplay) : '---';
  }
}
